import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QuillModule } from 'ngx-quill';
import { quillOptions } from '@services/utils/global-config';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { provideRootStore } from '@store/root-store/provide-root-store';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

const MODULES = [BrowserModule, BrowserAnimationsModule];

@NgModule({
  declarations: [],
  imports: [...MODULES, MatSnackBarModule, QuillModule.forRoot(quillOptions)],
  exports: [...MODULES],
  providers: [
    provideRootStore(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
      useValue: {
        _forceAnimations: true,
      },
    },
  ],
})
export class CoreModule {}
